export enum NextStepMethod {
  CONFIRM = 'CONFIRM',
  APPROVE_ORDER_ITEM_SECOND_STEP = 'APPROVE_ORDER_ITEM_SECOND_STEP',
  FORWARD_BALANCE_APPROVAL = 'FORWARD_BALANCE_APPROVAL',
  VALIDATE_PURCHASE_UNIT_VALUE = 'VALIDATE_PURCHASE_UNIT_VALUE',
  GENERATE_PURCHASE_REQUEST_INTEGRATION = 'GENERATE_PURCHASE_REQUEST_INTEGRATION',
  APPROVE_PURCHASE = 'APPROVE_PURCHASE',
  FINISH_ORDER_APPROVAL = 'FINISH_ORDER_APPROVAL',
}
